import * as Wildfire from "../../layers/static/Wildfire";

import base, { Config, StaticMapLayer } from "../../config";
import { camerasCoconinoMuseum, pipelineFire } from "../../layers/misc/cameras";

import FEMA_NFHL from "../../layers/dynamic/FEMA_NFHL";
import { LatLng } from "leaflet";
import notEmpty from "../../shared/notEmpty";

const staticLayers: StaticMapLayer[] = [
  {
    name: "Museum Fire Spruce Watershed",
    source: process.env.PUBLIC_URL + "/kml/MuseumFireWatershed.kml",
    visible: true,
  },
  {
    source: process.env.PUBLIC_URL + "/kml/schultzWatersheds.kml",
    name: "Schultz Basin Watersheds",
    visible: true,
  },
  {
    source:
      process.env.PUBLIC_URL + "/kml/PipelineWatersheds_WestSide_forweb.kml",
    name: "Pipeline Watershed (Westside)",
    visible: true,
  },
  Wildfire.current(),
].filter(notEmpty);

const config: Config = {
  ...base,
  ...{
    title: "Coconino County ALERT",
    center: new LatLng(35.258, -111.6),
    zoom: 12,
    agencyPassList: [
      "Coconino",
      "Flagstaff",
      "Coconino County",
      "City of Flagstaff",
      "United States Geological Survey",
      "Yavapai County",
    ],
    basemap: "Streets",
    defaultDisplay: { type: "precip", interval: "PT15M", measure: "total" },
    layers: {
      static: staticLayers,
      dynamic: [FEMA_NFHL],
      misc: [
        { name: "Museum Fire Cameras", cameras: camerasCoconinoMuseum },
        { name: "Pipeline Fire Cameras", cameras: pipelineFire },
      ],
      lightning: false,
      cbrfc: false,
      nwsWarnings: false,
    },
    markers: {
      ...base.markers,
      precip: {
        ...base.markers.precip,
        dotDisplayZoomLevel: 11,
      },
    },
    precipIntervals: {
      default: "PT15M",
      base: ["PT15M", "PT1H", "P1D"],
      more: ["PT30M", "PT3H", "PT6H", "PT12H", "P7D", "P30D"],
    },
  },
};

export default config;
